import { render, staticRenderFns } from "./IeltsComponentScore.vue?vue&type=template&id=57ba2d9c&"
import script from "./IeltsComponentScore.vue?vue&type=script&lang=js&"
export * from "./IeltsComponentScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports